import {
  COMPARE_METRIC_LOOKUP,
  CONTENT_METRICS,
  KDP_METRICS,
  METRIC_COLUMNS_BY_ENTITY,
  PRICING_METRICS,
  PROMO_METRICS,
} from "./metricsByEntity";
import checkApplication from "../../../../utils/checkApplication";
import { CONTENT, DEALS, DYNAMIC_PRICING } from "../../../../components/custom/merchandise/constants";
import buildMetricColumn, { type MetricColumn } from "../columns/buildMetricColumn";
import { useAppSelector } from "../../../../redux/hooks";
import { useMemo } from "react";
import { KDP_AUTHOR } from "../../../../utils/profileSubtypes";

export const useStandardEntityMetrics = (entityType: string | null | undefined) => {
  const user = useAppSelector((state) => state.user);
  return useMemo(() => {
    if (!entityType) {
      return [];
    }
    let entityMetrics = METRIC_COLUMNS_BY_ENTITY[entityType] ?? [];

    if (!checkApplication(user, DYNAMIC_PRICING)) {
      entityMetrics = entityMetrics.filter((id) => !PRICING_METRICS.includes(id));
    }

    if (entityType !== "content" && !checkApplication(user, CONTENT)) {
      entityMetrics = entityMetrics.filter((id) => !CONTENT_METRICS.includes(id));
    }

    if (!checkApplication(user, DEALS)) {
      entityMetrics = entityMetrics.filter((id) => !PROMO_METRICS.includes(id));
    }

    if (user.organization_subtype !== KDP_AUTHOR) {
      entityMetrics = entityMetrics.filter((id) => !KDP_METRICS.includes(id));
    }

    return entityMetrics;
  }, [entityType, user]);
};

export const extendAllEntityMetricOptions = <T>(
  standardIds: string[],
  data: { total?: T } | null | undefined,
  specifiedColumns: Array<MetricColumn<T>>,
  marketPlace: { marketPlace: string },
) => {
  for (const metricId of standardIds) {
    if (!COMPARE_METRIC_LOOKUP[metricId] || specifiedColumns.some((col) => col.id === metricId)) {
      continue;
    }
    try {
      const extraMetricSpec = buildMetricColumn(marketPlace, metricId, COMPARE_METRIC_LOOKUP[metricId], {
        checked: false,
      });

      // Dedupe by metric id (labels are resolved at render time from the byId table).
      if (!specifiedColumns.some((col) => col.id === extraMetricSpec.id)) {
        specifiedColumns.push({ ...extraMetricSpec });
      }
    } catch (error) {
      // oxlint-disable-next-line no-console
      console.warn(`Failed to build metric column for "${metricId}". Skipping.`, error);
    }
  }

  return specifiedColumns;
};
